export const RESOLVER_KEYS = {
  RAG_MATRIX: 'RAG_MATRIX',
  AUTO_UPDATES: 'AUTO_UPDATES',
}
